<template>
    <div>
        <div class="show">
            <div class="table-box">
                <div class="search-box">
                    <Button type="primary" @click="createConfirm">创建数据集</Button>
                </div>
                <Table  :columns="columns" :data="dataSetList.body"></Table>
                <div  class="page-box">
                    <Page :total="dataSetList.page.count" :page-size="page_size" :page-num="page_num" @on-change="change_page" v-if="dataSetList.page"/>
                </div>
            </div>
            <!--         创建数据集 -->
            <div v-if="create_dataSet">
                <create-dataset></create-dataset>
            </div>
            <select-mcp ref="selectMcp" :returnMcp="create" ></select-mcp>

            <delete-modal ref="deleteModal" title="删除数据集" :callbackFunc="deleteOk" ></delete-modal>
            <!-- 查看数据集详情-->
            <Modal
                    v-model="showDetail"
                    title="数据集详情"
                    width="700"
            >
                <Form label-position="left" :label-width="110">
                    <FormItem label="数据集名称" class="form-item">
                        {{detailInfo.name}}
                    </FormItem>
                    <FormItem label="描述信息">
                        {{detailInfo.remark}}
                    </FormItem>
                    <FormItem label="数据集文件" class="form-item">
                        <Table border
                               :columns="detailColumns"
                               :data="detailInfo.files"
                               size="small"
                               width="400"
                        ></Table>
                    </FormItem>
                </Form>
            </Modal>
        </div>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    import moment from 'moment'
    import CreateDataset from "./createDataSet"
    import SelectMcp from '../../common/selectMcp'
    import DeleteModal from '././../../common/deleteModal'
    export default {
        name:"dataSetList",
        components:{
            CreateDataset,
            SelectMcp,
            DeleteModal
        },
        methods:{
            ...mapActions({
                getDataSetList:'courseAdminDataSet/getDataSetList',
                deleteDateSet:'courseAdminDataSet/deleteDateSet',
            }),
            create(mcpId){
                this.$router.push({
                    name: 'createDataSetManag',
                    params: {mcpid: mcpId}
                });
            },
            getList(){
                let _this = this;
                // 获取数据集
                this.getDataSetList({
                    'data':{sort:'-name|ctime',page_num:_this.page_num,page_size:_this.page_size},
                    callback:(res,page)=>{
                        _this.dataSetList.body = res;
                        _this.dataSetList.page = page;
                    },
                    error:msg=>{
                        this.$Message.error(msg);
                    }
                })
            },
            // 翻页
            change_page(page){
                this.page_num = page;
                this.getList();
            },
            confirmDelete(url,id){
                this.currentId = id;
                this.currentMcpDomain = url;
                this.$refs.deleteModal.isshow(true)
            },
            deleteOk(){
                let _this = this;
                this.deleteDateSet({
                    id:this.currentId,
                    url:this.currentMcpDomain,
                    callback:res=>{
                        this.$Message.success("删除成功");
                        _this.getList();
                    },
                    error:msg =>{
                        _this.$Message.error({
                            content: msg,
                            duration:4
                        });
                    }
                })
            },
            createConfirm(){
                this.$refs.selectMcp.isshow(true)
            }
        },
        data(){
            return {
                showDetail:false,
                detailInfo:{name:'',remark:'',files:[]},
                dataSetList:{
                    page:{
                        count:0,
                        page_num:0,
                        page_size:0
                    }
                },
                detailColumns:[
                    {
                        title: '文件名',
                        key: 'name',
                        align: 'center',
                        tooltip:true
                    }
                ],
                currentId:null,
                currentMcpDomain:'',
                deleteModel:false,
                page_num:1,
                page_size:50,
                create_dataSet:false,
                columns:[
                    {
                        title:'ID',
                        key:'id',
                        width:65,
                        tooltip:true,
                        sortable: true
                    },
                    {
                        title:'数据集名称',
                        key:'name'
                    },
                    {
                        title:'创建人',
                        key:'create_user',
                        render:(h,params)=>{
                            return h('div',[h('span',{},params.row.create_user.name)])
                        }
                    },
                    {
                        title:'创建时间',
                        key:'ctime',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                }, moment(params.row.ctime).format('YYYY-MM-DD HH:mm:ss')),
                            ]);
                        }
                    },
                    {
                        title:'操作',
                        key:'action',
                        render:(h,params)=>{
                            return h('div',[
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.detailInfo = params.row;
                                            this.showDetail = true;
                                            // this.$router.push({
                                            //     name: 'detailDataSet',
                                            //     query: {id: params.row.id},
                                            // })
                                        }
                                    }
                                }, '查看'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6',
                                    },
                                    on: {
                                        click: () => {
                                            this.$router.push({
                                                name: 'editDataSetManag',
                                                params: {id: params.row.id},
                                            })
                                        }
                                    }
                                }, '编辑'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6',
                                        // display:params.row.create_user == this.user_info.id? 'inline-block':'none'
                                    },
                                    on: {
                                        click: () => {
                                            // this.delete(params.row.id)
                                            this.confirmDelete(params.row.mcp_endpoint.domain_name,params.row.id)
                                        }
                                    }
                                }, '删除')
                            ])
                        }
                    }
                ]
            }
        },
        mounted() {
            this.getList();
        }
    }
</script>
<style scoped lang="less">
    @import "../../../style/index";
</style>
